export function mockBackend (): boolean {
  return process.env.VUE_APP_MOCK_BACKEND === '1'
}
